<template>
	<a
		:class="['hyperlink', ...variantClassList, disabled && 'is-disabled']"
		:href="href"
		:disabled="disabled"
		@click="onClick"
		:target="target"
	>
		<span class="hyperlink__label">
			<slot>
				{{ labelText }}
			</slot>
		</span>
	</a>
</template>

<script>
import variantClasses from './variant-classes/hyperlink-variant-classes';
import componentVariantMixin from '@/mixins/component-variant-mixin';
import BaseComponentMixin from '@/mixins/base-component-mixin.js';

export default {
	name: 'Hyperlink',
	props: {
		labelText: {
			type: String,
			default: ''
		},
		href: {
			type: String,
			default: ''
		},
		target: {
			type: String,
			default: ''
			//'_blank' will open the hyperlink in a new tab
		}
	},
	mixins: [componentVariantMixin, BaseComponentMixin],
	created() {
		this.variantClasses = variantClasses;
	},
	methods: {
		onClick(e) {
			if (this.href === '') {
				e.preventDefault();
			}

			this.$emit('click', e);
		}
	}
};
</script>

<style lang="scss" scoped>
.hyperlink {
	$parent: &;

	display: inline-block;
	font-size: $txt-font-size;
	color: var(--link);

	&__label {
		border-bottom: 1px dotted var(--link);
	}

	&:hover,
	&:focus {
		color: var(--link-hover);
		#{$parent}__label {
			border-color: transparent;
		}
	}

	&--bg-brand-1 {
		color: var(--link-bg-brand-1);

		.hyperlink__label {
			border-color: var(--link-bg-brand-1);
		}

		&:hover,
		&:focus {
			color: var(--link-bg-brand-1);
		}
	}

	&--bg-brand-2 {
		color: var(--link-bg-brand-2);

		.hyperlink__label {
			border-color: var(--link-bg-brand-2);
		}

		&:hover,
		&:focus {
			color: var(--link-bg-brand-2);
		}
	}

	&--bg-brand-2-tint {
		color: var(--link-bg-brand-2-tint);

		.hyperlink__label {
			border-color: var(--link-bg-brand-2-tint);
		}

		&:hover,
		&:focus {
			color: var(--link-bg-brand-2-tint);
		}
	}
}

/* Tweak for Communication Component */
.toast {
	.hyperlink {
		color: $neutral-5;

		&__label {
			border-bottom: 1px dotted $neutral-3;

			&:hover,
			&:focus {
				border-color: transparent;
			}
		}
	}
}

.tooltip {
	.hyperlink {
		color: $neutral-5;
		font-size: 12px;

		&__label {
			border-bottom: 1px dotted $neutral-3;

			&:hover,
			&:focus {
				border-color: transparent;
			}
		}
	}
}
</style>
